import { cubicEaseOut } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { ButtonReset } from '@helpers/global';
import { Device, from } from '@helpers/media';
import { paragraphLarge, paragraphSmall } from '@helpers/typography';
import ButtonStyles from '@stories/Components/Buttons/Button/Button.styles';
import { m } from 'framer-motion';
import { rgba } from 'polished';
import styled from 'styled-components';
const Container = styled.div ``;
const Item = styled(m.div) `
  --borderColour: ${rgba(brand.primary.blue, 0.5)};
  border-bottom: 1px solid var(--borderColour);
`;
const ItemHeader = styled.button `
  ${paragraphLarge};
  ${ButtonReset};

  display: flex;
  align-items: flex-start;
  gap: 20px;
  padding: ${fluid(20, 24)} 0;
  margin: 0;
  text-align: left;
  width: 100%;

  ${Item}:first-child & {
    padding-top: 0;
  }

  &.focus-ring {
    outline: auto;
    outline-offset: 5px;
    outline-color: ${brand.black};
  }
`;
const ItemTitle = styled.h3 `
  display: block;
  flex: 1 1 auto;
  font-size: ${fluid(18, 24)};
  line-height: ${fluid(28, 34)};
  ${fonts.apparat.medium};
`;
const ItemIcon = styled.span `
  display: flex;
  transform: translateY(10px);
  transition: transform 0.25s ${cubicEaseOut};

  svg {
    width: 16px;
  }

  [aria-expanded='true'] & {
    transform: translateY(10px) rotate(-180deg);
  }
`;
const ItemTitleIcon = styled.span ``;
const ItemBody = styled(m.div) `
  min-width: 0;
  overflow: hidden;
`;
const ItemBodyContent = styled.div `
  padding-bottom: 30px;

  p:last-child {
    margin-bottom: 0;
  }

  p,
  ul li {
    ${paragraphSmall};
  }

  ul li {
    margin-bottom: 0;
  }

  a:not(${ButtonStyles.Container}) {
    ${fonts.apparat.bold}
    color: ${brand.primary.orange};
    text-decoration: underline;
    text-underline-position: under;
  }

  a:is(${ButtonStyles.Container}) {
    margin-top: ${fluid(20, 34)};
  }

  @media ${from(Device.TabletLarge)} {
    padding-bottom: 24px;
  }
`;
export default {
    Container,
    Item,
    ItemBody,
    ItemBodyContent,
    ItemHeader,
    ItemIcon,
    ItemTitle,
    ItemTitleIcon,
};
